import { ethicalFilms } from "@/mocks/movies";
import MovieCard from "./MovieCard";

export default function EthicalSection() {
  return (
    <section id="ethical" className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
        <div className="max-w-2xl">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            伦理片专区
          </h2>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
            侧重家庭、情感与社会关系的现实题材作品。这些影片不追求强烈的戏剧冲突，
            而是把镜头对准人与人之间微妙的选择与沉默，适合喜欢慢慢品的观众。
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          {["家庭伦理", "文艺剧情", "情感关系"].map((t) => (
            <span
              key={t}
              className="px-3 py-1 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-600"
            >
              {t}
            </span>
          ))}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {ethicalFilms.map((item) => (
          <div key={item.id} className="flex flex-col">
            <MovieCard item={item} showYear />
            <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}